export default function AlertIcon({
    style
}) {
    return <svg style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="9" fill="#EE5252" />
        <path d="M9 4.60156V10.0016" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="9" cy="13" r="1" fill="white" />
    </svg>

}